/* eslint-disable */
interface Images {
	readonly "cards": string
	readonly "iconChip": string
	readonly "iconDigitallabs": string
	readonly "iconMetamask": string
	readonly "iconMvp": string
	readonly "iconNowpayments": string
	readonly "iconOnramper": string
	readonly "iconProfile": string
	readonly "iconWallet": string
	readonly "imageBackground": string
	readonly "imageCasino": string
	readonly "imageDealer": string
	readonly "imageFootball": string
	readonly "imageHandOfCards": string
	readonly "imagePoker": string
	readonly "logoFb": string
	readonly "logoInsta": string
	readonly "logoMvp": string
	readonly "logoTwitter": string
	readonly "lottieConfetti": string
	readonly "lottieSpark": string
	readonly "lottieWinnerback": string
	readonly "lottieWinnerfront": string
}

interface RType {
    images: Images
}

export const R: RType = {
    images: {
		"cards": process.env.PUBLIC_URL + "/images/cards",
		"iconChip": process.env.PUBLIC_URL + "/images/icon_chip.webp",
		"iconDigitallabs": process.env.PUBLIC_URL + "/images/icon_digitallabs.webp",
		"iconMetamask": process.env.PUBLIC_URL + "/images/icon_metamask.svg",
		"iconMvp": process.env.PUBLIC_URL + "/images/icon_mvp.webp",
		"iconNowpayments": process.env.PUBLIC_URL + "/images/icon_nowpayments.webp",
		"iconOnramper": process.env.PUBLIC_URL + "/images/icon_onramper.webp",
		"iconProfile": process.env.PUBLIC_URL + "/images/icon_profile.svg",
		"iconWallet": process.env.PUBLIC_URL + "/images/icon_wallet.webp",
		"imageBackground": process.env.PUBLIC_URL + "/images/image_background.webp",
		"imageCasino": process.env.PUBLIC_URL + "/images/image_casino.webp",
		"imageDealer": process.env.PUBLIC_URL + "/images/image_dealer.webp",
		"imageFootball": process.env.PUBLIC_URL + "/images/image_football.webp",
		"imageHandOfCards": process.env.PUBLIC_URL + "/images/image_hand_of_cards.webp",
		"imagePoker": process.env.PUBLIC_URL + "/images/image_poker.webp",
		"logoFb": process.env.PUBLIC_URL + "/images/logo_fb.webp",
		"logoInsta": process.env.PUBLIC_URL + "/images/logo_insta.webp",
		"logoMvp": process.env.PUBLIC_URL + "/images/logo_mvp.webp",
		"logoTwitter": process.env.PUBLIC_URL + "/images/logo_twitter.webp",
		"lottieConfetti": process.env.PUBLIC_URL + "/images/lottie_confetti.json",
		"lottieSpark": process.env.PUBLIC_URL + "/images/lottie_spark.json",
		"lottieWinnerback": process.env.PUBLIC_URL + "/images/lottie_winnerback.json",
		"lottieWinnerfront": process.env.PUBLIC_URL + "/images/lottie_winnerfront.json",
    }
}

